<template>
    <div>
        <el-dialog :visible.sync="dialogVisible" width="38%" @close="handleClose">
            <div class="contact-dialog">
                <div class="contact-dialog-title">联系客服</div>
                <div class="contact-dialog-img">
                    <img :src="company.service_qrcode" alt="客服微信">
                </div>
                <el-button type="primary" size="small" @click="handleClose">关 闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import  { mapState } from 'vuex'

    export default {
        data() {
            return {
                dialogVisible:true
            }
        },
        computed:{
            ...mapState("company",['company'])
        },
        methods:{
            handleClose() {
                this.dialogVisible = false
                this.$emit('closeDialog')
            }
        }
    }
</script>

<style scoped>
.contact-dialog {
    text-align: center;
}
.contact-dialog-title {
    padding-bottom: 20px;
    font-size: 20px;
}
/deep/.el-dialog__body {
    padding: 20px;
}
.contact-dialog-img {
    margin-bottom: 20px;
}
</style>